import React from "react"
import markdown from "../../scripts/markdown"
import { parseDocumentCookies } from "../../scripts/utils"
import Icon from "../elements/Icon"
import { dispatch } from "../../Dispatcher"
import { filterHTML } from "../../scripts/xss"

class Notification extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isVisible: false
    }
  }

  _dismiss = e => {
    e.preventDefault()
    this.setState({ isVisible: false })
    this.props.browserSupport
      ? (document.cookie = "browserSupport=true;")
      : (document.cookie = "notificationId=" + this.props.details.id + ";")
    this.removeNotificationPadding()
  }

  _newBrowserNotification(existingCookies) {
    return this.props.browserSupport && !existingCookies.browserSupport
  }
  _newNotification(existingCookies) {
    return (
      !this.props.browserSupport &&
      existingCookies.notificationId != this.props.details.id
    )
  }

  removeNotificationPadding() {
    dispatch({ type: this.props.bodyClass, value: false })
  }

  componentDidMount() {
    const existingCookies = parseDocumentCookies()
    if (
      this._newNotification(existingCookies) ||
      this._newBrowserNotification(existingCookies)
    ) {
      dispatch({ type: this.props.bodyClass, value: true })
      this.setState({ isVisible: true })
    }
  }

  componentWillUnmount() {
    dispatch({ type: this.props.bodyClass, value: false })
  }

  render() {
    const { isVisible } = this.state

    return (
      <div>
        {isVisible &&
          this.props.details && (
            <div
              id="notification"
              className={"notification-bar row " + this.props.extraClasses}
            >
              <section
                className="c-article__content typography"
                itemProp="description"
                dangerouslySetInnerHTML={{
                  __html:
                    filterHTML(this.props.description) ||
                    markdown.render(filterHTML(this.props.details.description))
                }}
              />
              <button
                className="notification-bar__close"
                onClick={this._dismiss}
              >
                <Icon title="Close modal" icon="cross" />
              </button>
            </div>
          )}
      </div>
    )
  }
}

export default Notification



// WEBPACK FOOTER //
// ./webapp/components/modules/Notification.js